<template>
  <Card class="product-card">
    <img
      v-if="!placeholder"
      :src="product.mime[0]?.mimeSource?.[language] || ''"
    />
    <div class="product-card-info">
      <content-placeholders v-if="placeholder">
        <content-placeholders-img />
        <content-placeholders-heading />
        <content-placeholders-text />
      </content-placeholders>

      <div v-else>
        <div v-if="!placeholder" class="product-info-category">
          {{ categoryName }}
        </div>

        <h4>
          {{ product.overallInformation.descriptionShort[language] }}
        </h4>

        <p class="product-card-description">
          {{ product.overallInformation.descriptionLong?.[language] }}
        </p>
      </div>

      <router-link
        v-if="!placeholder"
        :to="`/product/${product.productId}?lang=${language}`"
      >
        <Button
          flat
          style="padding: 0.75rem 0"
          @click="handleSetSelectedProduct"
        >
          LEARN MORE
        </Button>
      </router-link>
    </div>
  </Card>
</template>

<script>
import Button from "../UI/Button.vue";
import Card from "../UI/Card.vue";

export default {
  name: "ProductCard",
  components: { Card, Button },
  props: {
    product: Object,
    language: {
      type: String,
      default: "en",
    },
    placeholder: Boolean,
  },
  methods: {
    handleSetSelectedProduct() {
      this.$store.commit("setSelectedProduct", this.product);
    },
  },
  computed: {
    categoryName() {
      const categoryList = this.$store.getters.categoryList;
      if (!categoryList?.length) {
        return "";
      }

      const categoryLeaves = this.product.categories.leaves?.["Rofix_Products"];

      if (!categoryLeaves?.length) {
        return "";
      }

      const categoryIdentifier = categoryLeaves[categoryLeaves.length - 1];

      const category = categoryList.find(
        (cat) => cat.identifier == categoryIdentifier
      );
      return category.name[this.language];
    },
  },
};
</script>

<style>
.product-card-info {
  padding: 10px 1em;
}

.product-card-info > h4 {
  margin: 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-info-category {
  color: var(--rofix-gray);
  font-size: var(--smaller-text);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-card-description {
  font-size: 14px;
  color: var(--rofix-gray);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-card > img {
  height: 200px;
  width: 100%;
  object-fit: contain;
}
</style>
